import React, { useState } from "react";
import { FieldValues } from "react-hook-form/dist/types/fields";
import { Adornments } from "./adornments";
import FormTextField, { IFormTextField } from "./FormTextField";

interface FormFieldPasswordProps<TFieldValues extends FieldValues = FieldValues>
  extends IFormTextField<TFieldValues> {
  correct?: boolean;
  onClickShowPassword?: () => void;
}

function FormTextFieldPassword<TFieldValues extends FieldValues = FieldValues>({
  correct,
  onClickShowPassword,
  ...props
}: FormFieldPasswordProps<TFieldValues>) {
  const [fieldType, setFieldType] = useState(props.fieldType);

  const handleClickShowPassword = () => {
    setFieldType(ft => (ft === "password" ? "text" : "password"));
  };

  return (
    <FormTextField
      {...props}
      InputProps={{
        endAdornment: (
          <Adornments
            position="end"
            type="verify-password"
            onClick={handleClickShowPassword}
            showPassword={fieldType === "text"}
          />
        )
      }}
      fieldType={fieldType}
    />
  );
}

export default FormTextFieldPassword;
